export default "__VITE_ASSET__fe9a35da__"